module.exports = __webpack_public_path__ + "img/AQ.16639f35.png";